import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { unseenPremiumActivitiesCountAtom } from '@root/features/pair-activity/atoms/reatom-premium-feed-table'
import { PremiumFeedDialog } from '@root/features/pair-activity/ui/premium-feed-dialog'
import { useTranslation } from '@root/shared/localization'
import { PremiumIcon, ReservedSpace } from '@root/shared/ui-kit'

export const PremiumFeedButton: React.FC = () => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [counter] = useAtom(unseenPremiumActivitiesCountAtom)

  const handleOpenChange = (open: boolean) => {
    setOpen(open)
  }

  const renderCounter = () => {
    const counter_ = counter >= 100 ? '99+' : counter.toString()

    return (
      <SquareCounter aria-disabled={counter === 0} aria-expanded={open}>
        <ReservedSpace $chars={counter_.length}>{counter_}</ReservedSpace>
      </SquareCounter>
    )
  }

  return (
    <PremiumFeedDialog open={open} onOpenChange={handleOpenChange}>
      <Root type="button" aria-disabled={!counter} aria-expanded={open}>
        <PremiumIcon size={12} />
        {t('premium.feed')}
        {renderCounter()}
      </Root>
    </PremiumFeedDialog>
  )
}

const Root = styled.button`
  --button-color: var(--subscriptionButton-9);
  --button-surface: color-mix(in srgb, var(--button-color) 10%, transparent);
  --button-surface-hover: color-mix(
    in srgb,
    var(--button-color) 50%,
    transparent
  );
  --button-text-muted: color-mix(in srgb, var(--button-color) 50%, transparent);

  all: unset;
  display: grid;
  height: 16px;
  text-transform: capitalize;
  padding-inline: 3px;
  padding-inline-end: 2px;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  cursor: pointer;

  border-radius: 4px;
  border: 1px solid var(--button-surface);
  transition: all 0.15s linear;

  background: var(--button-surface);
  color: var(--button-color);

  svg {
    color: var(--button-color);
  }
  &:not([aria-disabled='true']):hover {
    border-color: var(--button-surface-hover);
  }
  &[aria-expanded='true'] {
    opacity: 0.8;
  }
`
const SquareCounter = styled.span`
  background: var(--button-surface-hover);
  color: var(--button-text-muted);

  &[aria-disabled='false'] {
    background: var(--button-color);
    color: var(--appearance-1);
  }

  font-weight: 700;
  line-height: 1;
  border-radius: 2px;
  font-size: 8px;
  padding: 2px;
  height: 12px;
  min-width: 12px;

  display: grid;
  place-items: center;
  transition: all 0.15s linear;
`
